import { render, staticRenderFns } from "./CreateShipmentModal.vue?vue&type=template&id=06418350&scoped=true&"
import script from "./CreateShipmentModal.vue?vue&type=script&lang=js&"
export * from "./CreateShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipmentModal.vue?vue&type=style&index=0&id=06418350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06418350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06418350')) {
      api.createRecord('06418350', component.options)
    } else {
      api.reload('06418350', component.options)
    }
    module.hot.accept("./CreateShipmentModal.vue?vue&type=template&id=06418350&scoped=true&", function () {
      api.rerender('06418350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/CreateShipmentModal.vue"
export default component.exports